import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { getRedirectEditionUrl } from "@features/banner/Edition/utils/helpers";
import { IS_PLAYWRIGHT } from "@util/constant";
import Cookies from "js-cookie";

/** Hook to use to redirect BT Homepage to BTI homepage. */
export const useHomepageRedirect = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (IS_PLAYWRIGHT) return;

    const version = searchParams.get("region");
    const country = Cookies.get("sph_user_country");
    const userPreferredVersion = Cookies.get("preferred_region");

    if (country === "SG") return;
    if (userPreferredVersion === "SG") return;
    if (version === "sg") return;

    const redirectUrl = getRedirectEditionUrl().bti;
    window.location.href = redirectUrl;
  }, [searchParams]);
};
